export function generateFavicon(number: number): void {
  const canvas = document.createElement('canvas');
  canvas.width = 96;
  canvas.height = 96;
  const context = canvas.getContext('2d');

  // Load the existing favicon as an image
  const faviconImage = new Image();
  faviconImage.onload = () => {
    // Draw the favicon image on the canvas
    context.drawImage(faviconImage, 0, 0, canvas.width, canvas.height);

    // Draw a circle with a number in the center
    context.beginPath();
    context.arc(64, 32, 32, 0, 2 * Math.PI);
    context.fillStyle = '#FF0000';
    context.fill();
    context.font = 'bold 28px sans-serif';
    context.fillStyle = '#FFFFFF';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(number.toString(), 64, 32);

    // Create a new favicon link element
    const head = document.head || document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = 'custom-favicon';
    link.rel = 'shortcut icon';
    link.type = 'image/x-icon';
    link.href = canvas.toDataURL('image/x-icon');

    // Replace any existing favicon with the new one
    const existing = head.querySelector('link[rel="shortcut icon"]');
    if (existing) {
      head.removeChild(existing);
    }
    head.appendChild(link);
  };
  faviconImage.src = './../../assets/favicon.ico';
}
